// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5da78a9f","224":"53e33324","277":"8f03ac30","453":"58444c57","704":"0fa32521","895":"e977f28f"}[chunkId] + ".chunk.js";
};